import { render, staticRenderFns } from "./MinStock.vue?vue&type=template&id=42e61f7e&"
import script from "./MinStock.vue?vue&type=script&lang=js&"
export * from "./MinStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports